import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography, IconButton, makeStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 0)
  },
  definedByRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  definedByLabel: {
    marginRight: theme.spacing(0.5)
  },
  addButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.primary.main
  },
  emptyText: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  },
  noteText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary
  }
}));

export const ProjectCostOverridesDialogContent = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <div className={classes.definedByRow}>
        <Typography variant="body2" className={classes.definedByLabel}>
          <FormattedMessage id="projectCostOverrides.dialog.defineCostOverridesBy" />
        </Typography>
        <IconButton
          aria-label={formatMessage({
            id: 'projectCostOverrides.dialog.addCostOverride'
          })}
          className={classes.addButton}
          size="small"
          data-qe-id="ProjectCostOverridesDialogAddButton"
        >
          <AddCircleIcon />
        </IconButton>
      </div>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesDialogNoCostOverridesSet"
      >
        <FormattedMessage id="projectCostOverrides.dialog.noCostOverridesSet" />
      </Typography>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesDialogChooseToDefineOverrides"
      >
        <FormattedMessage id="projectCostOverrides.dialog.chooseToDefineOverrides" />
      </Typography>
      <Typography
        variant="body2"
        className={classes.noteText}
        data-qe-id="ProjectCostOverridesDialogNoteText"
      >
        <strong>
          <FormattedMessage id="projectCostOverrides.dialog.note" />
        </strong>
        <FormattedMessage id="projectCostOverrides.dialog.noteText" />
      </Typography>
    </div>
  );
};

export default ProjectCostOverridesDialogContent;
